var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1045 0.841797C12.3656 0.877843 12.5975 1.03542 12.7246 1.27148L13.832 3.33301H18.333C18.7932 3.33301 19.167 3.70675 19.167 4.16699C19.1668 4.62708 18.7931 5 18.333 5H17.083V18.333C17.083 18.7932 16.7102 19.167 16.25 19.167H3.75C3.28976 19.167 2.91699 18.7932 2.91699 18.333V5H1.66699C1.20686 5 0.833184 4.62708 0.833008 4.16699C0.833008 3.70675 1.20675 3.33301 1.66699 3.33301H6.17383L7.30664 1.2666L7.36719 1.1709C7.52295 0.960339 7.77081 0.833024 8.03711 0.833008H11.9902L12.1045 0.841797ZM4.58301 17.5H15.417V5H4.58301V17.5ZM8.33301 7.5C8.79314 7.5 9.16682 7.87292 9.16699 8.33301V13.75C9.16699 14.2102 8.79325 14.583 8.33301 14.583C7.87292 14.5828 7.5 14.2101 7.5 13.75V8.33301C7.50018 7.87303 7.87303 7.50018 8.33301 7.5ZM11.667 7.5C12.127 7.50018 12.4998 7.87303 12.5 8.33301V13.75C12.5 14.2101 12.1271 14.5828 11.667 14.583C11.2068 14.583 10.833 14.2102 10.833 13.75V8.33301C10.8332 7.87292 11.2069 7.5 11.667 7.5ZM8.07422 3.33301H11.9404L11.4922 2.5H8.53027L8.07422 3.33301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c7b9a885011c10847f9249bc7082e7a6.svg";
export { ForwardRef as ReactComponent };